import styled from 'styled-components';
import { colors, radius } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import { PrimaryButton } from '@ardoq/button';
import {
  AnimatedModalDialog,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@ardoq/modal';
import { ImagePreview } from './ImagePreview';
import { useImagePreview } from './useImagePreview';
import type { ImagePreviewErrorMessages } from './types';

const DynamicSizeModal = styled(FlexBox)`
  flex-direction: column;
  width: min(92vw, 1600px);
  height: 90vh;
  background-color: ${colors.surfaceDefault};
  border-radius: ${radius.r8};
  overflow: hidden;
`;

type LargeImagePreviewModalProps = {
  imageUrl: string | null;
  onClose: VoidFunction;
  closeButtonText?: string;
  errorMessages?: ImagePreviewErrorMessages;
};

export const LargeImagePreviewModal = ({
  imageUrl,
  onClose,
  closeButtonText = 'Close',
  errorMessages,
}: LargeImagePreviewModalProps) => {
  const { commands, state } = useImagePreview(errorMessages);

  return (
    <AnimatedModalDialog
      isOpen={imageUrl !== null}
      onClickOutside={onClose}
      onEscPress={onClose}
    >
      <DynamicSizeModal>
        <ModalHeader
          onCloseButtonClick={onClose}
          closeButtonLabel={closeButtonText}
        />
        <ModalBody>
          {imageUrl && (
            <ImagePreview
              url={imageUrl}
              {...state}
              commands={commands}
              height="100%"
            />
          )}
        </ModalBody>
        <ModalFooter>
          <PrimaryButton onClick={onClose}>{closeButtonText}</PrimaryButton>
        </ModalFooter>
      </DynamicSizeModal>
    </AnimatedModalDialog>
  );
};
